import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const notificationsApi = {
  triggerMorningNotifications: async () => {
    const response = await axios.post(
      `${API_URL}/api/admin/notifications/trigger-morning-notifications`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        }
      }
    );
    return response.data;
  },

  sendCustomNotification: async (title: string, message: string, userType: Array<string>) => {
    const response = await axios.post(
      `${API_URL}/api/admin/notifications/send-custom-notification`,
      { title, body: message, userType },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        }
      }
    );
    return response.data;
  },

  sendIndividualNotification: async (userId: string, title: string, body: string, data?: any) => {
    const response = await axios.post(
      `${API_URL}/api/admin/notifications/send-individual-notification/${userId}`,
      { title, body, data },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        }
      }
    );
    return response.data;
  }
};

export default notificationsApi;